/**
 * Environment Configuration
 * Centralized configuration for environment variables
 */

// Get environment variables with fallbacks
export const config = {
  // Environment
  env: import.meta.env.VITE_APP_ENV || 'development',
  
  // API Configuration
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8001/api/v1',
  
  // App Configuration
  appTitle: import.meta.env.VITE_APP_TITLE || 'Fables by Accoutre',
  debug: import.meta.env.VITE_APP_DEBUG === 'true',
  
  // Business timezone: reports use this clock regardless of the viewer's browser zone
  businessTimezone: import.meta.env.VITE_BUSINESS_TIMEZONE || 'Asia/Karachi',

  // Feature Flags
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  enablePwa: import.meta.env.VITE_ENABLE_PWA === 'true',
  
  // External Services
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  googleAnalyticsId: import.meta.env.VITE_GA_ID,
  appIcon: import.meta.env.VITE_API_BASE_URL + '/business-information/logo',
  appIconIco: import.meta.env.VITE_API_BASE_URL + '/business-information/logo/ico',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
};

// Environment checks
export const isDevelopment = config.env === 'development';
export const isTest = config.env === 'test';
export const isTunnel = config.env === 'tunnel';
export const isProduction = config.env === 'production';

// Debug logging
if (config.debug) {
  console.log('Environment Configuration:', config);
}

export default config;

